import React from 'react';

import { contentBuilderPropTypes } from '../../utils/propTypes';

import ContentDisplay from './ContentDisplay';
import ContentEditor from './ContentEditor';

const propTypes = contentBuilderPropTypes.content;

const QuizContent = (props) => {

	const {
		data,
		resourceContent,
		userId,
		isEditing,
		triggers,
		filestack,
		onCancel,
		onSave,
	} = props;

	const formID = data.data?.form_id;
	const form = data.data?.form;

	const id = data.id;
	const type = data.type;
	const title = resourceContent?.title;
	const width = data.width;
	const showTitle = data.show_title;
	const scope = data.scope;
	const scopeId = data.scope_id;

	// Check if we are still loading the associated quiz form
	if (formID && !form) {
		return <h1 className="p-3"><i className="fas fa-circle-notch fa-spin" /></h1>;
	}

	return (
		<div>
			{isEditing &&
				<ContentEditor
					id={id}
					type={type}
					title={title}
					data={data.data}
					width={width}
					scope={scope}
					scopeId={scopeId}
					form={form}
					filestack={filestack}
					onCancel={onCancel}
					onSave={onSave}
					onWidthChange={triggers?.onWidthChange} />
			}
			{!isEditing &&
				<ContentDisplay
					showTitle={showTitle}
					form={form}
					userId={userId} />
			}
		</div>
	);

};

QuizContent.propTypes = propTypes;

export default QuizContent;
